module.exports = __webpack_public_path__ + "static/img/designGuide9.d6ae203.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide9.png
// module id = Ar+p
// module chunks = 2